import React from 'react'
import DicSlider from '../components/DicSlider'

const Dicio = () => {
  return (
    <>
  <DicSlider/></>
  )
}

export default Dicio